import { Component, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CoreCommonModule } from '@core/common.module';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { BuyNewCardComponent } from './view/buy-card/buy-new-card/buy-new-card.component';
import { NgbModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ViewCartComponent } from './view/buy-card/view-cart/view-cart.component';
import { CardStepperComponent } from './view/buy-card/card-stepper/card-stepper.component';
import { CardStepperFooterComponent } from './view/buy-card/card-stepper-footer/card-stepper-footer.component';
import { TripInformationComponent } from './view/buy-card/1-trip-information/trip-information.component';
import { TravellerDetailsComponent } from './view/buy-card/2-traveller-details/traveller-details.component';
import { KYCComponent } from './view/buy-card/3-document/document.component';
import { A2FormComponent } from './view/buy-card/4-a2-form/a2-form.component';
import { PaymentComponent } from './view/buy-card/5-payment/payment.component';
import { LinkExistingCardComponent } from './view/link-existing-card/link-existing-card.component';
import { OrderSuccessComponent } from './view/order-success/order-success.component';
import { CardService } from './services/card.service';
import { ManageCardComponent } from './view/manage-card/manage-card.component';
import { MyCardComponent } from './view/card-dashboard/my-card.component';
import { ValidateCardDetailsComponent } from './view/validate-card-details/validate-card-details';
import { LoaderRoutingModule } from 'app/shared/utility/utility-routing.module';
import { CashoutComponent } from './view/cashout/cashout.component';
import { TransferBalanceComponent } from './view/transfer-balance/transfer-balance.component';
import { NouisliderModule } from 'ng2-nouislider';
import { SetDailyLimitComponent } from './view/manage-card/set-daily-limit/set-daily-limit.component';
import { CommonModule, DatePipe } from '@angular/common';
import { CardSnippetModule } from '@core/components/card-snippet/card-snippet.module';
import { AddBankAccountForCardComponent } from './view/buy-card/add-bank-account-card/add-bank-account-card.component';
import { UpdateProfileService } from '../update-profile/services/update-profile.service';
import { StatementComponent } from './view/statement/statement.component';
import { AuthGuard } from 'app/auth/helpers/auth.guards';
import { RaiseDisputeTicketComponent } from './view/raise-dispute-ticket/raise-dispute-ticket.component';
import { PassportDataFormComponent } from './view/passport-data-form/passport-data-form.component';
import { RemittanceRoutingModule } from '../remittance/remittance-routing.module';
import { TransferToINRWalletComponent } from './view/transfer-to-inr-wallet/transfer-to-inr-wallet.component';
import { AddAddressCardComponent } from './view/buy-card/add-address-card/add-address-card.component';
import { EncashmentComponent } from './view/encashment/encashment.component';
import { LinkCardComponent } from './view/link-card/link-card.component';
import { ActivateINRWallet } from './view/activate-inr-wallet/activate-inr-wallet.component';
import { MyFeaturesComponent } from './view/features/my-features.component';
import { MyFaqsComponent} from './view/faqs/my-faqs.component';
import { NewCardComponent} from './view/newcard/newcard.component';
import { NewFeaturesComponent} from './view/newfeatures/newfeatures.component';
import { EsimComponent} from './view/esim/esim.component';
import { LinkEsimCardComponent} from './view/link-esim-card/link-esim-card.component';
import { InternationalEsimComponent} from './view/international-esim/international-esim.component';
import { LinkInternationalCardComponent} from './view/link-international-card/link-international-card.component';
import { LoungeAccessComponent} from './view/lounge-access/lounge-access.component';
import { StudentFaqComponent } from './view/student-faq/student-faq.component';
import { CardListComponent } from './view/cards/card-list.component';
import { SwiperModule, SwiperConfigInterface, SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { FlexLayoutModule } from '@angular/flex-layout';
import { GlobalPayFeaturesComponent } from './view/globalpay-features/globalpay-features.component';
import { TravelPayFeaturesComponent } from './view/travelpay-features/travelpay-features.component';
import { BuyInternationalEsimComponent } from './view/buy-international-esim/buy-international-esim.component';
import { LinkBuyEsimComponent } from './view/link-buy-esim/link-buy-esim.component';
import { LoungeListComponent } from './view/lounge-access/lounge-list/lounge-list.component';
import { BuyLoungeComponent } from './view/lounge-access/lounge-buy/buy-lounge-access.component';
import { EsimFormComponent } from './view/esim/esim-form/esim-form.component';



import { SpendnEarnComponent } from './view/spend-n-earn/spend-n-earn.component';
import { ESignCardComponent } from './view/buy-card/3-esign/card-esign.component';
import { GlobalMultiFeaturesComponent } from './view/global-multi-features/global-multi-features.component';
import { XplorerCardRequestComponent } from './view/xplorer-card/view/xplorer-card-request/xplorer-card-request.component';
import { XplorerCardActivationFormComponent } from './view/xplorer-card/view/xplorer-card-activation-form/xplorer-card-activation-form.component';
import { XplorerCardFeatureComponent } from './view/xplorer-card/view/xplorer-feature/xplorer-feature.component';
import { FeaturesComponent } from './view/card-features/card-features.component';
import { EncashESignComponent } from './view/encashment-esign/encashment-esign.component';
import { XplorerCardPaymentPageComponent } from './view/xplorer-card/view/xplorer-payment-page/xplorer-payment-page.component';





const routes = [
  {
    path: 'buy-new-card',
    component: BuyNewCardComponent,
    data: { animation: 'BuyNewCardComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'view-cart',
    component: ViewCartComponent,
    data: { animation: 'ViewCartComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'card-stepper',
    component: CardStepperComponent,
    data: { animation: 'CardStepperComponent' },
    canActivate: [AuthGuard]
  },
  // {
  //   path: 'link-existing-card',
  //   component: LinkExistingCardComponent,
  //   data: { animation: 'LinkExistingCardComponent' },
  //   canActivate: [AuthGuard]
  // },
  {
    path: 'order-success',
    component: OrderSuccessComponent,
    data: { animation: 'OrderSuccessComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'my-card',
    component: MyCardComponent,
    data: { animation: 'MyCardComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'activate-inr-wallet',
    component: ActivateINRWallet,
    data: { animation: 'ActivateINRWallet' },
    canActivate: [AuthGuard]
  },
  {
    path: 'manage-card',
    component: ManageCardComponent,
    data: { animation: 'MyCardComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'validate-card-details',
    component: ValidateCardDetailsComponent,
    data: { animation: 'ValidateCardDetailsComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'cashout',
    component: CashoutComponent,
    data: { animation: 'CashoutComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'transfer-balance',
    component: TransferBalanceComponent,
    data: { animation: 'TransferBalanceComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'set-daily-limit',
    component: SetDailyLimitComponent,
    data: { animation: 'SetDailyLimitComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'add-bank-account-for-card',
    component: AddBankAccountForCardComponent,
    data: { animation: 'AddBankAccountForCardComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'statement',
    component: StatementComponent,
    data: { animation: 'StatementComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'raise-dispute-ticket',
    component: RaiseDisputeTicketComponent,
    data: { animation: 'RaiseDisputeTicketComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'passport-data-form',
    component: PassportDataFormComponent,
    data: { animation: 'PassportDataFormComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'cashout-to-inr-wallet',
    component: TransferToINRWalletComponent,
    data: { animation: 'TransferToINRWalletComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'encashment/:orderId',
    component: EncashmentComponent,
    data: { animation: 'EncashmentComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'link-card',
    component: LinkCardComponent,
    data: { animation: 'LinkCardComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'my-features',
    component: MyFeaturesComponent,
    data: { animation: 'MyFeaturesComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'my-faqs',
    component: MyFaqsComponent,
    data: { animation: 'MyFaqsComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'newcard',
    component: NewCardComponent,
    data: { animation: 'NewCardComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'newfeatures',
    component: NewFeaturesComponent,
    data: { animation: 'NewFeaturesComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'esim',
    component: EsimComponent,
    data: { animation: 'EsimComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'link-forex-card',
    component: LinkEsimCardComponent,
    data: { animation: 'LinkEsimCardComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'international-esim',
    component: InternationalEsimComponent,
    data: { animation: 'InternationalEsimComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'link-international-card',
    component: LinkInternationalCardComponent,
    data: { animation: 'LinkInternationalCardComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'lounge-access',
    component: LoungeAccessComponent,
    data: { animation: 'LoungeAccessComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'student-card-faq',
    component: StudentFaqComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cards',
    component: CardListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'globalpay-features',
    component: GlobalPayFeaturesComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'travelpay-features',
    component: TravelPayFeaturesComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'spend-n-earn',
    component: SpendnEarnComponent, 
    canActivate: [AuthGuard]
  },
  {
    path: 'buy-international-esim',
    component: BuyInternationalEsimComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'link-buy-esim',
    component: LinkBuyEsimComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'lounge-list',
    component: LoungeListComponent,
    canActivate: [AuthGuard]
  },  
  {
    path: 'buy-lounge',
    component: BuyLoungeComponent,
    canActivate: [AuthGuard]
  },  
  {
    path: 'esim-form',
    component: EsimFormComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'global-multi-features',
    component: GlobalMultiFeaturesComponent,
    data: { animation: 'NewFeaturesComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'xplorer-card-request',
    component: XplorerCardRequestComponent,
    data: { animation: 'NewFeaturesComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'xplorer-card-activation-form',
    component: XplorerCardActivationFormComponent,
    data: { animation: 'NewFeaturesComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'xplorer-feature',
    component: XplorerCardFeatureComponent,
    data: { animation: 'NewFeaturesComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'features/:cardType',
    component: FeaturesComponent,
    data: { animation: 'NewFeaturesComponent' },
    canActivate: [AuthGuard]
  },
  {
    path: 'xplorer-payment-page',
    component: XplorerCardPaymentPageComponent,
    data: { animation: 'NewFeaturesComponent' },
    canActivate: [AuthGuard]
  },
  
  


 
];

@NgModule({
  declarations: [
    BuyNewCardComponent,
    ViewCartComponent,
    CardStepperComponent,
    TripInformationComponent,
    TravellerDetailsComponent,
    KYCComponent,
    A2FormComponent,
    PaymentComponent,
    CardStepperFooterComponent,
    LinkExistingCardComponent,
    OrderSuccessComponent,
    MyCardComponent,
    ActivateINRWallet,
    ManageCardComponent,
    ValidateCardDetailsComponent,
    CashoutComponent,
    TransferBalanceComponent,
    SetDailyLimitComponent,
    AddBankAccountForCardComponent,
    StatementComponent,
    RaiseDisputeTicketComponent,
    PassportDataFormComponent,
    TransferToINRWalletComponent,
    AddAddressCardComponent,
    EncashmentComponent,
    MyFeaturesComponent,
    MyFaqsComponent,
    NewCardComponent,
    NewFeaturesComponent,
    EsimComponent,
    LinkEsimCardComponent,
    InternationalEsimComponent,
    LinkInternationalCardComponent,
    LoungeAccessComponent,
    StudentFaqComponent,
    CardListComponent,
    GlobalPayFeaturesComponent,
    TravelPayFeaturesComponent,
    SpendnEarnComponent,
    BuyInternationalEsimComponent,
    LinkBuyEsimComponent,
    LoungeListComponent,
    BuyLoungeComponent,
    EsimFormComponent,
    ESignCardComponent,
    GlobalMultiFeaturesComponent,
    XplorerCardRequestComponent,
    XplorerCardActivationFormComponent,
    XplorerCardFeatureComponent,
    FeaturesComponent,
    EncashESignComponent,
    XplorerCardPaymentPageComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    CoreCommonModule,
    FormsModule,
    NgSelectModule,
    NgbTooltipModule,
    NgbModule,
    LoaderRoutingModule,
    CommonModule,
    CardSnippetModule,
    NouisliderModule,
    SwiperModule,
    FlexLayoutModule
  ],
  exports: [
    BuyNewCardComponent,
    ViewCartComponent,
    CardStepperComponent,
    TripInformationComponent,
    TravellerDetailsComponent,
    KYCComponent,
    A2FormComponent,
    PaymentComponent,
    CardStepperFooterComponent,
    LinkExistingCardComponent,
    OrderSuccessComponent,
    MyCardComponent,
    ActivateINRWallet,
    ValidateCardDetailsComponent,
    CashoutComponent,
    TransferBalanceComponent,
    SetDailyLimitComponent,
    AddBankAccountForCardComponent,
    StatementComponent,
    RaiseDisputeTicketComponent,
    PassportDataFormComponent,
    AddAddressCardComponent,
    EncashmentComponent,
    MyFeaturesComponent,
    MyFaqsComponent,
    NewCardComponent,
    NewFeaturesComponent,
    EsimComponent,
    LinkEsimCardComponent,
    InternationalEsimComponent,
    LinkInternationalCardComponent,
    LoungeAccessComponent,
    GlobalPayFeaturesComponent,
    TravelPayFeaturesComponent,
    SpendnEarnComponent,
    BuyInternationalEsimComponent,
    LinkBuyEsimComponent,
    ESignCardComponent,
    GlobalMultiFeaturesComponent,
    XplorerCardRequestComponent,
    XplorerCardActivationFormComponent,
    XplorerCardFeatureComponent,
    FeaturesComponent,
    EncashESignComponent,
    XplorerCardPaymentPageComponent
  ],
  providers: [CardService, UpdateProfileService, DatePipe]
})
export class CardRoutingModule { }
